export var IDENTIFIER_LOADER = 'loader';
